import * as React from 'react';
import { SiteContext } from '../context/SiteContext';
import { useInterval } from './useInterval';
import { useMap } from './useMap';
import { useTimeout } from './useTimeout';

interface IUseInlineMap {
  mapId: string;
  mapStyles: any;
}

export const useInlineMap = (args: IUseInlineMap) => {
  const [mapElement, setMapElement] = React.useState<any>(null);
  const [polling, setPolling] = React.useState(true);
  const { googleMapInstance, googleMapsInitialized } = React.useContext(
    SiteContext
  );

  useMap();

  useInterval({
    cb: () => {
      const domElement = document.getElementById(args.mapId);
      setMapElement(domElement);
    },
    delay: !mapElement && polling ? 200 : null,
  });

  useTimeout(() => {
    setPolling(false);
  }, 2500);

  React.useEffect(() => {
    if (googleMapInstance && googleMapsInitialized && mapElement) {
      const coordinates = mapElement?.dataset?.coordinates;
      if (coordinates) {
        const [lat, lon] = mapElement?.dataset?.coordinates.split(';');
        if (lat && lon) {
          let settings: any = {
            disableDefaultUI: true,
            zoomControl: false,
            zoom: 14,
          };

          if (args?.mapStyles) {
            settings.styles = args.mapStyles;
          }

          const center = {
            lat: Number(lat),
            lng: Number(lon),
          };

          const map = new googleMapInstance.maps.Map(mapElement, {
            ...settings,
            center,
          });

          new googleMapInstance.maps.Marker({
            position: center,
            map: map,
          });
        }
      }
    }
  }, [googleMapInstance, googleMapsInitialized, mapElement]);
};
